import riot from "../lib/riot.js";

window.riot = riot;
